import cashier from '@/locales/en/cashier.json';
import common from '@/locales/en/common.json';
import errors from '@/locales/en/errors.json';
import methods from '@/locales/en/methods.json';
import outcome from '@/locales/en/outcome.json';
import proof from '@/locales/en/proof.json';

/**
 * Only `en` is bundled statically; `es` and `pt` arrive by dynamic import when the switcher selects
 * them, so a player never downloads a locale they are not reading (`Performance.md` §4).
 *
 * `en` must be static because it is the `fallbackLng`: a missing key in a dynamically loaded locale
 * has to resolve to something on the first render, and a payment screen cannot wait on a network
 * round-trip to find out what a label says.
 */
export const enResources = {
  common,
  cashier,
  methods,
  proof,
  outcome,
  errors,
} as const;

export type EnResources = typeof enResources;
